/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {Date}
     * @memberof Account
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    email?: string;
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    favoriteTeamId: number;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Account
     */
    lastSeenDate: Date;
    /**
     * 
     * @type {AccountProviderEnum}
     * @memberof Account
     */
    provider?: AccountProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    status: string;
    /**
     * 
     * @type {Date}
     * @memberof Account
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    username: string;
}


/**
 * @export
 */
export const AccountProviderEnum = {
    Cognito: 'cognito',
    Google: 'google'
} as const;
export type AccountProviderEnum = typeof AccountProviderEnum[keyof typeof AccountProviderEnum];


/**
 * Check if a given object implements the Account interface.
 */
export function instanceOfAccount(value: object): value is Account {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('favoriteTeamId' in value) || value['favoriteTeamId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lastSeenDate' in value) || value['lastSeenDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function AccountFromJSON(json: any): Account {
    return AccountFromJSONTyped(json, false);
}

export function AccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Account {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['created_at'])),
        'email': json['email'] == null ? undefined : json['email'],
        'favoriteTeamId': json['favorite_team_id'],
        'id': json['id'],
        'lastSeenDate': (new Date(json['last_seen_date'])),
        'provider': json['provider'] == null ? undefined : json['provider'],
        'status': json['status'],
        'updatedAt': (new Date(json['updated_at'])),
        'username': json['username'],
    };
}

export function AccountToJSON(json: any): Account {
    return AccountToJSONTyped(json, false);
}

export function AccountToJSONTyped(value?: Account | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created_at': value['createdAt'].toISOString(),
        'email': value['email'],
        'favorite_team_id': value['favoriteTeamId'],
        'id': value['id'],
        'last_seen_date': value['lastSeenDate'].toISOString(),
        'provider': value['provider'],
        'status': value['status'],
        'updated_at': value['updatedAt'].toISOString(),
        'username': value['username'],
    };
}

